import React from 'react';
import 'twin.macro';
import { PeriodeWeekTag } from 'components/PeriodeWeekTag';
import { format } from 'utils/time/format';
import FullSmallDot from 'components/Icons/icons/FullSmallDot';
import { CahierJournalView } from 'containers/CahierJournal/types';
import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';
import { useUser } from 'containers/App/context/useUser';

interface Props {
  view: CahierJournalView;
  date: Date;
}

export function SubDateInfos(props: Props) {
  const { date, view } = props;
  const { locale } = useUser();
  const classrooms = useClassrooms();
  const isNotDayView = view !== 'day';
  return (
    <div tw="flex justify-center items-center gap-x-2 flex-wrap">
      <PeriodeWeekTag date={date} minimal />{' '}
      {!isNotDayView && (
        <span tw="text-xs text-muted">{format(date, locale, 'yyyy')}</span>
      )}
      {classrooms.length === 1 && (
        <>
          <FullSmallDot />
          <div
            style={{
              maxWidth: '16rem',
            }}
            tw="text-xs text-muted font-medium truncate"
          >
            {classrooms[0].name}
          </div>
        </>
      )}
    </div>
  );
}
